import { z } from 'zod'

export const SkuEditFormSchema = z.object({
  name: z.string().min(1, {
    message: 'catalog.products.detail.skus.edit.form.name.required',
  }),
})

export type SkuEditFormValues = z.infer<typeof SkuEditFormSchema>
